import {
    FETCH_LATEST_CLIENT_VERSION_BEGIN,
    FETCH_LATEST_CLIENT_VERSION_SUCCESS,
    SAVE_NEW_CLIENT_VERSION_BEGIN,
    SAVE_NEW_CLIENT_VERSION_ERROR,
    SAVE_NEW_CLIENT_VERSION_SUCCESS
} from "../actions/clientUpdateActions";

const defaultLatestClientUpdate = {
    latestClientUpdate: null,
    loading: false,
}

const defaultSavedNewClientUpdate = {
    savedNewClientUpdate: null,
    loading: false,
}

export const latestClientUpdateReducer = (state = defaultLatestClientUpdate, action) => {
    switch (action.type) {
        case FETCH_LATEST_CLIENT_VERSION_BEGIN:
            return {
                ...state,
                loading: true
            };
        case FETCH_LATEST_CLIENT_VERSION_SUCCESS:
            return {
                ...state,
                loading: false,
                latestClientUpdate: action.payload.latestClientUpdate
            };

        default:
            return state;
    }
};

export const saveClientUpdateReducer = (state = defaultSavedNewClientUpdate, action) => {
    switch (action.type) {
        case SAVE_NEW_CLIENT_VERSION_BEGIN:
            return {
                ...state,
                loading: true
            };
        case SAVE_NEW_CLIENT_VERSION_SUCCESS:
            return {
                ...state,
                loading: false,
                savedNewClientUpdate: action.payload.savedNewClientUpdate
            };
        case SAVE_NEW_CLIENT_VERSION_ERROR:
            return {
                ...state,
                loading: false,
            }

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/clientUpdate.js